export const extractParams = (url) => {
  if (!url) return {};
  const queryPart = url.includes('?') ? url.split('?')[1] : url;
  const params = new URLSearchParams(queryPart);
  const obj = {};
  for (const [key, value] of params.entries()) {
    obj[key] = value;
  }
  return obj;
};

export const replaceParams = (url, params = {}) => {
  let newUrl = url;
  for (const [key, value] of Object.entries(params)) {
    newUrl = newUrl.replace(`:${key}`, encodeURIComponent(value));
  }
  return newUrl;
};

export default {
  extractParams,
  replaceParams,
};
